(() => {
  const init = (root) => {
    if (root.dataset.bundleReady) return;
    root.dataset.bundleReady = 'true';
    const form = root.querySelector('form');
    const config = JSON.parse(root.querySelector('[data-bundle-config]').textContent);
    const quantity = form.querySelector('[name="quantity"]');
    const button = form.querySelector('[data-bundle-add]');
    const status = root.querySelector('[data-bundle-status]');
    const cartLink = root.querySelector('[data-bundle-cart]');
    const planInputs = [...form.querySelectorAll('input[name="selling_plan"]')];
    const requestedPlan = new URL(window.location.href).searchParams.get('selling_plan');
    const linkedPlan = requestedPlan === null ? null : planInputs.find((input) => input.value === requestedPlan);
    if (linkedPlan) planInputs.forEach((input) => { input.checked = input === linkedPlan; });
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: config.currency || 'USD'});
    let busy = false;
    const update = () => {
      const count = Math.max(1, Math.floor(Number(quantity.value) || 1));
      root.querySelectorAll('[data-bundle-unit-price]').forEach((el) => {
        el.textContent = money.format(Number(el.dataset.bundleUnitPrice) * count / 100);
      });
      root.querySelectorAll('.ll-bundle-catalog__plan').forEach((el) => {
        el.classList.toggle('is-selected', el.querySelector('input').checked);
      });
    };
    form.addEventListener('change', update);
    quantity.addEventListener('input', update);
    form.querySelector('[data-bundle-variant]')?.addEventListener('change', (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', event.target.value);
      url.searchParams.delete('selling_plan');
      window.location.assign(url.toString());
    });
    root.querySelectorAll('[data-bundle-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const image = root.querySelector('[data-bundle-main-image]');
        if (!image) return;
        image.removeAttribute('srcset');
        image.src = thumb.dataset.src;
        image.alt = thumb.dataset.alt;
        root.querySelectorAll('[data-bundle-thumb]').forEach((other) => {
          const selected = other === thumb;
          other.classList.toggle('is-current', selected);
          other.setAttribute('aria-pressed', String(selected));
        });
      });
    });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      const count = Number(quantity.value);
      if (!Number.isSafeInteger(count) || count < 1) return;
      const data = new FormData(form);
      const item = {id: Number(data.get('id')), quantity: count};
      const plan = data.get('selling_plan');
      if (plan) item.selling_plan = Number(plan);
      busy = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.hidden = true;
      cartLink.hidden = true;
      try {
        const response = await fetch(`${config.root}cart/add.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [item]})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || config.error);
        status.textContent = config.added;
        status.hidden = false;
        cartLink.hidden = false;
        try {
          if (typeof window.upcartRefreshCart === 'function') await window.upcartRefreshCart();
          if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
        } catch (_) {
          // The item was added; keep the cart link available without resubmitting.
        }
      } catch (error) {
        status.textContent = error.message || config.error;
        status.hidden = false;
      } finally {
        busy = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
    update();
  };
  document.querySelectorAll('[data-bundle-catalog]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-bundle-catalog]').forEach(init);
  });
})();
